import { render } from "./MtLedgerDetail.vue?vue&type=template&id=6bb1b6b6&scoped=true"
import script from "./MtLedgerDetail.vue?vue&type=script&lang=js"
export * from "./MtLedgerDetail.vue?vue&type=script&lang=js"

import "./MtLedgerDetail.vue?vue&type=style&index=0&id=6bb1b6b6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bb1b6b6"]])

export default __exports__